// Generic client-side validation + ajax submission for the lien-he contact
// forms (partnership, consultation). Required fields are read from the
// markup's `[required]` attributes rather than hard-coded per form, and
// email/phone fields are found by `type` — this lets both forms (which have
// different field names) share one binding function. Mirrors the
// validate → disable-button-with-spinner → fetch → redirect shape already
// used by checkout-submit.js.
const PHONE_PATTERN = /^(0|\+84)(3[2-9]|5[25689]|7[06-9]|8[1-9]|9[0-46-9])[0-9]{7}$/;

function isValidPhone(value) {
	return PHONE_PATTERN.test(value.replace(/[\s.-]/g, ''));
}

function isValidEmail(value) {
	return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value);
}

function showError(errorEl, message) {
	errorEl.textContent = message;
	errorEl.hidden = false;
}

function clearError(errorEl) {
	errorEl.hidden = true;
	errorEl.textContent = '';
}

function fieldLabel(field) {
	return field.closest('.form-field')?.querySelector('.form-field__label')?.textContent.trim() || field.name;
}

function validateForm(form, errorEl) {
	const missing = Array.from(form.querySelectorAll('[required]'))
		.filter((field) => !field.value.trim())
		.map(fieldLabel);

	if (missing.length) {
		showError(errorEl, `Vui lòng điền: ${missing.join(', ')}`);
		return false;
	}

	const emailField = form.querySelector('input[type="email"]');
	if (emailField && !isValidEmail(emailField.value.trim())) {
		showError(errorEl, 'Email không hợp lệ.');
		return false;
	}

	const phoneField = form.querySelector('input[type="tel"]');
	if (phoneField && !isValidPhone(phoneField.value.trim())) {
		showError(errorEl, 'Số điện thoại không hợp lệ.');
		return false;
	}

	return true;
}

function bindContactForm(form, { action, nonceKey }) {
	const errorEl = form.querySelector('.form__error');

	form.addEventListener('submit', (e) => {
		e.preventDefault();
		clearError(errorEl);

		if (!validateForm(form, errorEl)) {
			return;
		}

		const submitButton = form.querySelector('button[type="submit"]');
		const originalLabel = submitButton.textContent;
		submitButton.disabled = true;
		submitButton.innerHTML = '<span class="btn__spinner" aria-hidden="true"></span>Đang gửi...';

		const body = new URLSearchParams();
		for (const [key, value] of new FormData(form)) {
			body.set(key, value);
		}
		body.set('action', action);
		body.set('nonce', window.hgthemeData[nonceKey]);

		fetch(window.hgthemeData.ajaxUrl, { method: 'POST', body })
			.then((res) => res.json())
			.then((data) => {
				if (data.success) {
					window.location.href = '/cam-on-lien-he/';
					return;
				}
				showError(errorEl, data.data?.message || 'Có lỗi xảy ra, vui lòng thử lại.');
				submitButton.disabled = false;
				submitButton.textContent = originalLabel;
			})
			.catch(() => {
				showError(errorEl, 'Có lỗi xảy ra, vui lòng thử lại.');
				submitButton.disabled = false;
				submitButton.textContent = originalLabel;
			});
	});
}

document.addEventListener('DOMContentLoaded', () => {
	const partnershipForm = document.getElementById('partnership-form');
	if (partnershipForm) {
		bindContactForm(partnershipForm, { action: 'hgtheme_partnership_submit', nonceKey: 'partnershipNonce' });
	}

	const consultationForm = document.getElementById('consultation-form');
	if (consultationForm) {
		bindContactForm(consultationForm, { action: 'hgtheme_consultation_submit', nonceKey: 'consultationNonce' });
	}
});
